import { useContent } from '../../../hooks/use-server-content';

export interface DyfFeatureGuideBreadcrumbAemContent {
    supportBreadcrumb: string;
    modelBreadcrumb: string;
    brandBreadcrumb: string;
    overviewArticleBreadcrumb?: string;
    relatedArticlesBreadcrumb?: string;
    htvVideoLibraryBreadcrumb?: string;
}
export const useDyfFeatureGuideBreadcrumbsContent = (): DyfFeatureGuideBreadcrumbAemContent => {
    const [content, getValueByName] = useContent(
        'dyf/feature-guide',
        'dyf-feature-guide-breadcrumbs'
    );
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as DyfFeatureGuideBreadcrumbAemContent;
};
